import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class MobileFilters extends ThemeComponent {
    @Ref({required: false}) overlay!: HTMLDivElement;

    init() {
        this.$listen(this.overlay, 'click', () => {
            document.dispatchEvent(new Event('closeFilterDrawer'));
        });
    }
}
